module.exports = __webpack_public_path__ + "img/top.264ac79c.png";